import React from 'react'
import { Button, useRefresh, useNotify, useUnselectAll, } from 'react-admin'
import IconBlock from '@material-ui/icons/Block'
import { bulckRejectPublicCloudStorage } from '../../../Model/publicCloudStorage'


const handleAssignClick = (selectedIds, resource, refresh, notify, unselectAll) => {
    const data = {
        "sid[]": selectedIds,
    }
    bulckRejectPublicCloudStorage(data, (res) => {
        refresh()
        unselectAll(resource)
        notify(res.message)
    }, (res) => {
        notify(res.message, 'warning')
    })

}

const BulkRejectButton = ({ selectedIds, resource }) => {
    const refresh = useRefresh()
    const notify = useNotify()
    const unselectAll = useUnselectAll()
    return (
        <Button label="Bulk Reject" style={{ color:'orange',border:'1px solid'}} icon={<IconBlock />} onClick={() => {
            handleAssignClick(selectedIds, resource, refresh, notify, unselectAll)
        }} />
    );
}

export default BulkRejectButton